import { Action, defaultActions } from '#/common/components/DataGrid';
import { Model } from '#/graphql/types';

export const actions: Action<Model>[] = [...defaultActions];
